import { createAction, props } from '@ngrx/store';
import { ClearResponse, LegacyClearResponse } from '@shared/services/clear/clear.service';

export const ClearStart = createAction('[Clear] Clear API Call Start');
export const ClearEnd = createAction(
  '[Clear] Clear API Call End',
  props<{ payload: LegacyClearResponse | ClearResponse }>(),
);

export const ClearError = createAction('[Clear] Clear API Call Error');
